import React from "react";
import { useTranslation } from "react-i18next";

import { navbarItems } from "../header/utils/navbarItems";
import { socialMedias } from "./utils/socialMedias";

import classes from "./index.module.css";
import CallIcon from "@mui/icons-material/Call";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className={classes["wrapper"]}>
      <div className={classes["school-number"]}>{t("249-School")}</div>
      <div className={classes["nav-items"]}>
        {navbarItems.map((item) => {
          return (
            <a key={item.id} className={classes["small-text"]} href={item.path}>
              {t(item.title)}
            </a>
          );
        })}
      </div>
      <a href="tel:+998988880448" className={classes["phone-number"]}>
        <CallIcon style={{ transform: "scale(1.5)" }} /> +998 98 888 04 48
      </a>
      <div className={classes["small-text"]}>249maktab@gmail.com</div>
      <div className={classes["social-medias"]}>
        {socialMedias.map((socialMedia) => {
          return (
            <div className={classes["social-media"]} key={socialMedia.id}>
              {socialMedia.icon}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Footer;
